import {State} from '../types/state'

export const getScheduleItems = (state: State) => state.schedule?.items

export const getScheduleItemsTotal = (state: State) => state.schedule?.total

export const hasScheduleItems = (state: State) => Boolean(state.schedule?.items?.length)
